/**************************************************
 * Nombre:       Dialogo_Espacio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Checkbox, Grid, Typography} from "@mui/material";
import Formulario_Espacio from "../Formularios/Formulario_Espacio";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../Recursos/logo_redondo.svg";
import {theme} from "../../Tema";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {envioNuevoRegistro} from "../../Utilidades/envioNuevoRegistro";
import dayjs from "dayjs";
import {useState} from "react";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";
import {obtenerIndicativo} from "../../Modulo_formularios/Funciones/obtenerIndicativo";


const Dialogo_Espacio = ({datos, cerrar}) => {
    const {props, obtenerEntidad, limpiarEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, nuevoAviso, Avisos, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: limpiarEntidad,
        funcionDos: cerrar
    })
    const [acepta, setAacepta] = useState(false)

    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Enviando Formulario')
        entidad.estado = 'Nuevo'
        entidad.notificaciones = acepta
        entidad.celular = limpiarCelular(entidad.celular)
        entidad.indicativo = obtenerIndicativo(entidad.pais)

        let dox = await guardarDoc('potencialesEspacios', entidad)
        if (dox.res) {
            await envioNuevoRegistro(entidad)
            terminar({aviso: 'Registro realizado con exito, te haremos llegar el link de la reunion'})
        } else {
            terminar({aviso: 'Algo salio mal,intentalo nuevamente', variante: "error"})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 2}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{
                    fontSize: 24,
                    fontWeight: 800,
                    lineHeight: 1.1
                }}>{datos.espacio}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{
                    fontSize: 18, fontWeight: 400, lineHeight: 1.1,
                    color: theme.palette.primary.main
                }}>{datos.profesional}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{
                    fontSize: 18,
                    fontWeight: 400,
                    lineHeight: 1.1
                }}>{dayjs(datos.fechaEspacio).format('dddd, D [de] MMMM')}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography sx={{
                    fontSize: 18,
                    fontWeight: 400,
                    lineHeight: 1.1
                }}>{dayjs(datos.fechaEspacio).format('h:mm a [Argentina]')}</Typography>
            < /Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Formulario_Espacio props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 12}}>
                    <Checkbox value={acepta} onChange={() => setAacepta(!acepta)}/> Aceptas nuestra politica de
                    tratamiento de datos
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3, mb: 0}}>
                <Button
                    variant={acepta ? 'contained' : 'outlined'}
                    onClick={() => enviarDatos()}
                >Enviar</Button>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Espacio